import axios from 'axios';
import { getToken } from './auth';
import { config } from '../config';

const api = axios.create({
  baseURL: config.backendUrl
});

// Automatically include JWT
api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;